import React from 'react';

import { type MotionProps } from 'framer-motion';

import { NFTAsset } from '@pkg/components/Sections/Groups/GroupCard';
import { useWishlistThumbnails } from '@pkg/hooks';

import { type WishlistItem } from '@app/client/common/structs/wishlists/wishlists';

import { BottomRight, Left, TopRight, Wrapper } from './styles';

interface Props extends MotionProps {
    isSmall?: boolean;
    assets?: string[];
    items?: WishlistItem[];
}

export const WishlistThumbnail = ({ isSmall, items, style, assets = [] }: Props) => {
    const { thumbnailAssets } = useWishlistThumbnails({ items, assets });
    const [leftAsset, topAsset, rightAsset] = thumbnailAssets;

    return (
        <Wrapper $isSmall={isSmall} style={style}>
            <Left $isSmall={isSmall}>
                {leftAsset && (
                    <NFTAsset hideLoadingMarkup noErrorText errorSquareBackground={false} imageUrl={leftAsset} />
                )}
            </Left>
            <TopRight>
                {topAsset && (
                    <NFTAsset hideLoadingMarkup noErrorText errorSquareBackground={false} imageUrl={topAsset} />
                )}
            </TopRight>

            <BottomRight>
                {rightAsset && (
                    <NFTAsset hideLoadingMarkup noErrorText errorSquareBackground={false} imageUrl={rightAsset} />
                )}
            </BottomRight>
        </Wrapper>
    );
};
